/* Fanette — favicon animé : le « f » orange fait un petit salut toutes les quelques secondes */
(function () {
  var link = document.querySelector('link[rel~="icon"]');
  if (!link || !window.HTMLCanvasElement) return;
  var src = link.getAttribute('href');
  var apple = document.querySelector('link[rel="apple-touch-icon"]');
  if (apple && apple.getAttribute('href')) src = apple.getAttribute('href');
  var S = 64, c = document.createElement('canvas'); c.width = c.height = S;
  var g = c.getContext('2d'), img = new Image();
  img.crossOrigin = 'anonymous';
  img.onload = function () {
    var icon = document.createElement('link');
    icon.rel = 'icon'; icon.type = 'image/png';
    document.querySelectorAll('link[rel~="icon"]').forEach(function (l) { if (l.rel !== 'apple-touch-icon') l.remove(); });
    document.head.appendChild(icon);
    var BG = '#F4EDE1', DUR = 1100, PAUSE = 3200, t0 = performance.now(), last = '';
    var draw = function (p) {
      /* p de 0 à 1 : petit saut, rebond et balancement */
      var e = Math.sin(p * Math.PI);
      var jump = -Math.abs(Math.sin(p * Math.PI * 2)) * 6 * (1 - p * .4);
      var rot = Math.sin(p * Math.PI * 3) * 0.16 * (1 - p);
      var sx = 1 + Math.sin(p * Math.PI * 4) * 0.06 * (1 - p), sy = 2 - sx;
      g.fillStyle = BG; g.fillRect(0, 0, S, S);
      g.save();
      g.translate(S / 2, S / 2 + jump + e * 0);
      g.rotate(rot); g.scale(sx * 1.18, sy * 1.18);
      g.drawImage(img, -S / 2, -S / 2, S, S);
      g.restore();
      var url = c.toDataURL('image/png');
      if (url !== last) { icon.href = url; last = url; }
    };
    var tick = function () {
      if (document.hidden) { draw(0); return; }
      var t = (performance.now() - t0) % (DUR + PAUSE);
      draw(t < DUR ? t / DUR : 0);
    };
    draw(0);
    setInterval(tick, 50);
  };
  img.src = src.replace(/_(32x32|128x128)\./, '_128x128.');
})();

/* Fanette — CTA (texte qui roule + petit cœur), pictos camée / panier d'osier, étoiles orange */
(function () {
  var NS = 'http://www.w3.org/2000/svg';
  var HEART = '<svg class="f-heart" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.2s-7.6-4.6-7.6-10.1A4.2 4.2 0 0 1 12 7.6a4.2 4.2 0 0 1 7.6 2.5c0 5.5-7.6 10.1-7.6 10.1z"/></svg>';
  var ICONS = {
    account: '<ellipse cx="12" cy="12" rx="7.6" ry="9.6" stroke-width="1.1"/><ellipse cx="12" cy="12" rx="5.7" ry="7.7" stroke-width=".8"/><circle cx="12" cy="9.6" r="2.1" stroke-width="1.1"/><path d="M8.4 17.4c.6-2.4 2-3.6 3.6-3.6s3 1.2 3.6 3.6" stroke-width="1.1"/><circle class="f-dot" cx="12" cy="2.4" r=".9"/>',
    cart: '<path d="M5.2 9.2h13.6l-1.3 11.3H6.5z" stroke-width="1.1"/><path d="M7.1 11h9.8l-.95 7.7H8.05z" stroke-width=".8"/><path d="M9 9.2V7.4a3 3 0 0 1 6 0v1.8" stroke-width="1.1"/><circle class="f-dot" cx="12" cy="14.8" r=".95"/>'
  };
  var icons = function () {
    document.querySelectorAll('#shopify-section-header .header-action-account svg:not(.f-ico), #shopify-section-header .header-action-cart svg:not(.f-ico)').forEach(function (s) {
      var kind = s.closest('.header-action-account') ? 'account' : 'cart';
      var n = document.createElementNS(NS, 'svg');
      n.setAttribute('viewBox', '0 0 24 24'); n.setAttribute('aria-hidden', 'true');
      n.setAttribute('class', 'f-ico f-ico--' + kind);
      n.setAttribute('stroke-linecap', 'round'); n.setAttribute('stroke-linejoin', 'round');
      n.innerHTML = ICONS[kind];
      s.parentNode.replaceChild(n, s);
    });
  };
  var ctas = function () {
    document.querySelectorAll('.fw-btn, .fw-link, .fw-hero__sub, a.btn, button.btn').forEach(function (b) {
      if (b.dataset.fCta) return;
      var txt = (b.textContent || '').trim();
      if (!txt || b.querySelector('svg, img, i')) return;
      b.dataset.fCta = '1';
      b.classList.add('f-cta');
      var t = document.createElement('span'); t.className = 'f-roll';
      var a = document.createElement('span'); a.textContent = txt;
      var c = document.createElement('span'); c.textContent = txt; c.setAttribute('aria-hidden', 'true');
      t.appendChild(a); t.appendChild(c);
      b.textContent = ''; b.appendChild(t);
      b.insertAdjacentHTML('beforeend', HEART);
      if (getComputedStyle(b).display === 'inline') b.style.display = 'inline-flex';
      b.style.alignItems = 'center'; b.style.gap = '.8rem';
    });
  };
  var stars = function () {
    document.querySelectorAll('.topheader *:not(.f-star)').forEach(function (el) {
      [].slice.call(el.childNodes).forEach(function (n) {
        if (n.nodeType === 3 && n.nodeValue.indexOf('✦') > -1) {
          var f = document.createDocumentFragment();
          n.nodeValue.split('✦').forEach(function (part, i) {
            if (i) { var s = document.createElement('span'); s.className = 'f-star'; s.textContent = '✦'; f.appendChild(s); }
            f.appendChild(document.createTextNode(part));
          });
          n.parentNode.replaceChild(f, n);
        }
      });
    });
  };
  var RADISH = 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="2 1 37 59"><path d="M17.2 31.6c-.6-2.4-1.6-4-3-5M19.6 31.4c-.3-3.4 0-6.2.8-8.6M21.4 31.6c1.2-2.2 2.6-3.8 4.4-5" fill="none" stroke="#55562F" stroke-width="1.1" stroke-linecap="round"/><g transform="translate(0 -4.5)"><path d="M17.6 30.6c-.4-3.4-1.6-5.9-3.9-7.4-2.1-1.4-4.6-1-6.6.4-2.6 1.9-3.7 5.1-3.2 7.6.4 1.8 2 2.5 3.6 1.8 2-.9 3.4-2.6 4.2-4.4 2.3-.3 4.4.5 5.9 2z" fill="#55562F"/><path d="M19.5 30.4c-.8-5.6.2-10.4 2.6-14.8-1.7-2.5-1.5-5.8.6-7.9 2.3-2.3 6-2.6 8.4-1.1 1.8 1.1 2.2 3.3 1.3 5.4-1.3 3.2-3 6.4-5.6 8.8-2.9 2.6-4.9 5.8-5.9 9.6z" fill="#55562F"/><path d="M21.2 30.8c1.7-3.8 3.8-6.8 7-8.6 2.3-1.3 4.8-1.3 6.4 0 1.4 1.1 1.5 3 .6 4.4-.7 1.2-1.1 2.7-2 3.5-1.4 1.2-3.1.8-3.9-.5-.9-1.4-2.6-1.7-4.2-1.1-1.4.6-2.7 1.4-3.9 2.3z" fill="#55562F"/><path d="M8.3 26.6c2.6-.4 5.2 1 6.6 3.4M27 10.2c-1.8 3.6-3.4 7.6-5.6 11.4M24.6 27.4c2.2-1.6 4.8-2.2 7.2-1.6" fill="none" stroke="#F7F1EA" stroke-width=".55" stroke-linecap="round"/></g><path d="M20 30.2c6.8 0 11.6 3.5 11.6 8.9 0 4.7-3.4 8.1-7.9 9.2-2.2.5-3.3 1.8-3.7 3.4-.4-1.6-1.5-2.9-3.7-3.4-4.5-1.1-7.9-4.5-7.9-9.2 0-5.4 4.8-8.9 11.6-8.9z" fill="#FF4215"/><path d="M15.6 45.3c1.4.2 2.6.9 3.3 2l1.3-1.8.5 1.3c1-.7 2.3-1 3.6-1" fill="none" stroke="#F7F1EA" stroke-width=".55" stroke-linecap="round" stroke-linejoin="round"/><path d="M20 50.6c-.5 2.7.1 5 1.8 6.5.9.8 1.5 1.6 1.2 2.8" fill="none" stroke="#FF4215" stroke-width="1.4" stroke-linecap="round"/></svg>');
  var placeRadishes = function (svg) {
    var text = svg.querySelector('text'); if (!text || !text.getExtentOfChar) return;
    svg.querySelectorAll('.f-rad').forEach(function (n) { n.remove(); });
    var str = text.textContent;
    for (var k = 0; k < str.length; k++) {
      if (str.charAt(k) !== '✦') continue;
      try {
        var e = text.getExtentOfChar(k), r = text.getRotationOfChar(k);
        var cx = e.x + e.width / 2, cy = e.y + e.height / 2;
        var im = document.createElementNS(NS, 'image');
        im.setAttribute('class', 'f-rad'); im.setAttribute('href', RADISH);
        im.setAttribute('x', cx - 3); im.setAttribute('y', cy - 4.8); im.setAttribute('width', 6); im.setAttribute('height', 9.6);
        im.setAttribute('transform', 'rotate(' + r + ' ' + cx + ' ' + cy + ')');
        svg.appendChild(im);
      } catch (err) {}
    }
  };
  var seals = function () {
    document.querySelectorAll('.fw-hero__sub.f-cta:not(.f-seal), .fw-split .f-cta:not(.f-seal)').forEach(function (b, i) {
      var first = b.querySelector('.f-roll > span');
      var txt = (first ? first.textContent : b.textContent).trim().replace(/[<&]/g, '');
      var id = 'f-seal-path-' + i + '-' + Math.random().toString(36).slice(2, 7);
      var ring = '', len = 0; do { ring += txt + ' <tspan class="f-sep">✦</tspan> '; len += txt.length + 3; } while (len < 22);
      b.classList.add('f-seal');
      b.setAttribute('aria-label', txt);
      b.innerHTML = '<svg class="f-ring" viewBox="0 0 100 100" aria-hidden="true"><defs><path id="' + id + '" d="M50 50m-40 0a40 40 0 1 1 80 0a40 40 0 1 1-80 0"/></defs><text><textPath href="#' + id + '" textLength="249" lengthAdjust="spacing">' + ring + '</textPath></text></svg><span class="f-core" aria-hidden="true">' + HEART + '</span>';
      var svg = b.querySelector('.f-ring');
      var go = function () { placeRadishes(svg); };
      requestAnimationFrame(go);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(go);
      setTimeout(go, 1200);
    });
  };
  var labels = function () {
    document.querySelectorAll('.fw-tiles .fw-tile').forEach(function (tile) {
      if (tile.querySelector('.f-tile-label')) return;
      var box = document.createElement('span'); box.className = 'f-tile-label';
      ['.fw-tile__title', '.fw-tile__text', '.fw-btn'].forEach(function (sel) { var el = tile.querySelector(sel); if (el) box.appendChild(el); });
      tile.appendChild(box);
    });
  };
  var SOLD_RE = /^(épuisé|epuisé|épuisée|sold out|vendu|vendue|rupture de stock|indisponible)$/i;
  var soldOut = function () {
    document.querySelectorAll('[data-product-form-sold-out-text]').forEach(function (el) { el.setAttribute('data-product-form-sold-out-text', 'Trop tard :) Elle a déjà trouvé sa maison'); });
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT), n, hits = [];
    while ((n = walker.nextNode())) { if (SOLD_RE.test((n.nodeValue || '').trim())) hits.push(n); }
    hits.forEach(function (node) {
      var box = node.parentElement && node.parentElement.closest('button, a, .fw-tag, [class*="badge"], [class*="sold"], span, div');
      var inBtn = node.parentElement && node.parentElement.closest('button, input[type=submit], .btn');
      node.nodeValue = inBtn ? 'Trop tard :) Elle a déjà trouvé sa maison' : 'Trop tard :)';
      if (box && box.textContent.trim() === node.nodeValue) box.classList.add('f-soldout');
      if (inBtn) inBtn.classList.add('f-soldout-btn');
    });
  };
  var run = function () { icons(); ctas(); seals(); stars(); labels(); soldOut(); };
  var moT;
  if (window.MutationObserver) new MutationObserver(function () { clearTimeout(moT); moT = setTimeout(soldOut, 150); }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
  setTimeout(run, 1500);
})();
